import { z } from "zod";
import { DistanceSchema } from "./race";

export const UserRaceRelationSchema = z.enum(["bookmarked", "registered", "finished"]);
export type UserRaceRelation = z.infer<typeof UserRaceRelationSchema>;

export const UserRaceSchema = z.object({
  userId: z.string().uuid(),
  raceId: z.string(),
  relation: UserRaceRelationSchema,
  finishTimeSec: z.number().int().positive().nullable(),
  distance: DistanceSchema.nullable(),
  note: z.string().max(500).nullable(),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});
export type UserRace = z.infer<typeof UserRaceSchema>;
